import * as React from 'react'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import { cva } from 'class-variance-authority'

import { cn } from '~/lib/utils'

const bar = cva('h-full w-full flex-1 transition-all ', {
  variants: {
    colour: {
      default: 'bg-blue-m dark:bg-white',
      'light-blue': 'bg-blue-l dark:bg-blue-l',
      chartreuse: 'bg-char dark:bg-char',
      white: 'bg-white dark:bg-white'
    }
  },
  defaultVariants: {
    colour: 'default'
  }
})

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    className?: string
    value?: number | null | undefined
    max?: number | undefined
    barColour: 'light-blue' | 'chartreuse' | 'white' | undefined | null
  }
>(({ className, barColour, value, max = 100, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'h-2xs-plus bg-grey-l dark:bg-blue-d-80 relative w-full overflow-hidden',
        className
      )}
      {...props}
      aria-label='Progress bar'
    >
      <ProgressPrimitive.Indicator
        className={cn(bar({ colour: barColour }))}
        {...props}
        style={{
          transform: `translateX(-${100 - ((value || 0) / max) * 100}%)`
        }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
